<template>
  <div>
    <v-system-bar v-if="textoAlerta || editing" color="yellow lighten-5 pa-10">
      <v-card-text v-if="editing" class="text-center text-h5 pa-0 mt-10 font-weight-bold d-flex">
        <v-text-field
          id="input_texto_alerta"
          v-model="textoAlerta"
          maxlength="1000"
          placeholder="Insira aqui uma mensagem de alerta"
          class="ma-5"
          dense
          solo
        />

        <v-btn
          id="btn_salvar_alerta"
          @click="save"
          class="mx-2 mt-5"
          fab
          small
          outlined
          color="green"
        >
          <v-icon color="green"> check </v-icon>
        </v-btn>
      </v-card-text>

      <v-card-text v-else class="lineUp text-center text-h5 pt-4 font-weight-bold piscar">
        <div>
          <v-menu open-on-hover top>
            <template v-slot:activator="{ on, attrs }" v-if="!isAluno()">
              <div class="alerta-container mt-5" v-bind="attrs" v-on="on" @click="abrirModal">
                <div class="esconde-texto">
                  {{ textoAlerta }}
                </div>
                <div v-if="bloquearEdicao === true" class="clique-ver-mais">
                  <v-icon small color="primary">mdi-information-outline</v-icon>
                  Clique para ver completo
                </div>
              </div>
            </template>

            <v-list class="text-center" v-if="bloquearEdicao === false">
              <v-list-item>
                <v-list-item-title>
                  <v-btn
                    id="btn-ver-completo-alerta"
                    @click="abrirModal"
                    class="mx-2 mt-0"
                    outlined
                    color="primary"
                  >
                    <v-icon color="primary"> mdi-text-box-outline </v-icon>
                    Ver Completo
                  </v-btn>
                  <v-btn
                    id="btn-editar-alerta"
                    @click="edit()"
                    class="mx-2 mt-0"
                    outlined
                    color="green"
                  >
                    <v-icon color="green"> edit </v-icon>
                    Editar Texto
                  </v-btn>
                  <v-btn
                    id="btn-remover-alerta"
                    @click="deleteAlerta"
                    class="mx-2 mt-0"
                    outlined
                    color="red"
                  >
                    <v-icon color="red"> delete </v-icon>
                    Remover Alerta
                  </v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </v-card-text>
    </v-system-bar>

    <!-- Modal para exibir texto completo -->
    <v-dialog v-model="dialogTextoCompleto" max-width="600">
      <v-card>
        <v-card-title class="yellow lighten-5 pa-4">
          <v-icon color="warning" class="mr-2">mdi-alert</v-icon>
          <span class="text-h6 font-weight-bold">Alerta do Sistema</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="fecharModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-6 texto-modal">
          {{ textoAlerta }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="fecharModal"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
    },
    novo: {
      type: Boolean,
    },
  },
  watch: {
    novo(valor) {
      if (valor === true) {
        this.editing = true;
      }
    },
  },
  data() {
    return {
      textoAlerta: "",
      editing: false,
      informativo: null,
      bloquearEdicao: true,
      dialogTextoCompleto: false,
    };
  },
  mounted() {
    this.getRoleAtual();
    this.getInformativo();
  },
  methods: {
    async getRoleAtual() {
      const roleAtual = await this.$services.authService.getCurrentUser();
      if (roleAtual.roles[0].name === "super-admin" || roleAtual.roles[0].name === "admin") {
        this.bloquearEdicao = false;
      } else {
        this.$emit("bloquearBotaoNovo", true);
      }
    },

    async getInformativo() {
      try {
        const infor = await this.$services.informativosService.syncAll();
        if (infor.length) {
          this.ocultarBotaoNovo();
          this.informativo = infor[0];
          this.textoAlerta = infor[0].texto;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    ocultarBotaoNovo() {
      this.$emit("situacaoBtnAlerta", false);
    },

    async save() {
      if (!this.textoAlerta || !this.textoAlerta.trim()) {
        this.$toast.danger("O texto do alerta não pode estar vazio!");
        return;
      }
      this.editing = false;
      try {
        await this.$services.informativosService.create({ texto: this.textoAlerta });
        this.ocultarBotaoNovo();
        this.editing = false;
      } catch (error) {
        this.$handleError(error);
      }
    },

    edit() {
      this.editing = true;
    },

    isAluno() {
      return this.user?.roleName === "aluno";
    },

    async deleteAlerta() {
      try {
        await this.$services.informativosService.delete();
        this.textoAlerta = null;
        this.novo = false;
        this.$emit("situacaoBtnAlerta", true);
      } catch (error) {
        this.$handleError(error);
      }
    },

    abrirModal() {
      this.dialogTextoCompleto = true;
    },

    fecharModal() {
      this.dialogTextoCompleto = false;
    },
  },
};
</script>

<style scoped>
.texto-modal {
  font-size: 20px;
  line-height: 1.5;
}

.alerta-container {
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 16px;
  border-radius: 4px;
  position: relative;
}

.alerta-container:hover {
  background-color: rgba(255, 193, 7, 0.1);
  transform: translateY(-2px);
}

.esconde-texto {
  max-width: 90vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.clique-ver-mais {
  font-size: 1.1rem;
  color: #1976d2;
  font-weight: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  opacity: 0.8;
  transition: opacity 0.3s ease;
}

.alerta-container:hover .clique-ver-mais {
  opacity: 1;
  font-weight: 500;
}
</style>
